<template>
    <div v-if="selectedHeat != ''" id="v-editor">
        <div class="editor f-column">
            <div class="header f-row">
                <div><span class="start-pos">{{ Entrant.startPos }}</span> &nbsp; <span class="bib">{{ Entrant.bib }}</span></div>
                <div class="try" v-if="Entrant.results.length != 0">
                    <!-- <select v-model="cResultId" @change="changeTry">
                        <option v-for="(r, i) in Entrant.results" v-bind:key="i" :value="i">{{r.value.toFixed(2)}}</option>
                    </select> -->
                    {{Entrant.results[cResultId].value.toFixed(2)}}{{$t('text.heightShort')}}
                </div>
            </div>
            <div class="name-label">{{ Entrant.name }} ({{Entrant.classShort}})</div>                
            <div class="f-row result-input">
                <div class="f-column">
                    <div>
                        <a href="javascript:;" ref="result" @keydown="onKeyDown"><div class="ruler"></div><div class="f-grow field" :class="{blink: IsResultCurrent}">{{ resultString }}</div></a>
                    </div>
                </div>
                <div class="rank">
                    {{getRank}}
                </div>
            </div>  
            <div class="f-column input" @click="confirmValue">              
                <div class="f-row buttons">
                    <div class="failed">X</div>
                    <div class="success">O</div>
                    <div class="del" @click="backSpace"></div>
                </div>
                <div class="f-row buttons">
                    <div>-</div>
                    <div>r</div>  
                </div>
            </div>
            
            <div class="footer f-row" v-if="IsResultCurrent">
                <div>{{$t('text.next')}}: <span class="start-pos">{{ NextEntrant.startPos }}</span> &nbsp; <span class="bib">{{ NextEntrant.bib }}</span> &nbsp; {{ NextEntrant.results[getNextResultId].value.toFixed(2) }}{{$t('text.heightShort')}}: {{ NextEntrant.results[getNextResultId].highjumpTries }} <br>{{ NextEntrant.name }} ({{Entrant.classShort}})</div>
                <div class='button arrow-buttons next' @click="nextEntrant(false)"></div>
            </div>
            <div class="footer f-row" v-if="!IsResultCurrent">
                <button @click="abortEdit">{{$t('text.abort')}}</button>
                <button @click="setNewCurrent">{{$t('text.setCurrent')}}</button>
                <button @click="saveEdit">{{$t('text.save')}}</button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';
import glAct from '../store/actions/global';
import glMut from '../store/mutations/global';
import navMut from '../store/mutations/navigation';

export default {
    name: "EditResult",
    data: function(){
        return {
            cResultId: 0,
            cEntrantId: 0,
            resultString: "",
            originalResultString: null,
            nextEntrantId: 0,
            nextResultId: 0,
            overAllResult: new Array(),            
            request: (data) => {
                if(data.id === this.SelectedHeat.id) {
                    this.setNextEntrant(data);
                }
            }
        }
    },
    methods:{
        ...mapActions([glAct.SENDRESULT,
            glAct.SENDHEATGROUP,
            glAct.SENDCURRENTCURSOR]),
        ...mapMutations([
            glMut.REGISTERHUB,
            glMut.UNREGISTERHUB,
            glMut.SETRESULTIDS,
            glMut.RANKUPDATE,
            navMut.SHOWNAVPOINT,
            navMut.HIDENAVPOINT]),
        setNextEntrant(data){
            if(!!data.nextEntry){
                var i = this.selectedHeat.entries.findIndex(x => x.id == data.nextEntry);
                this.nextEntrantId = i;
                this.nextResultId = this.selectedHeat.entries[i].results.findIndex(x => x.heightId == data.nextHeight);
            }
            else{
                this.nextEntrantId = 0;
                this.nextResultId = 0;
            }
            this.SETRESULTIDS({
                eId: null,
                rId: null, 
                src: 'cc',
                nEId: this.nextEntrantId,
                nRId: this.nextResultId,
            });
        },
        changeTry(){
            this.SETRESULTIDS({eId: this.cEntrantId ,rId: this.cResultId, src: 'other'});
        },
        abortEdit(){   
            this.Entrant.results[this.cResultId].highjumpTries = this.originalResultString;      
            this.SETRESULTIDS({eId: this.CEntryId ,rId: this.CResultId, src: 'other'});
        },
        setNewCurrent(){
            this.SENDHEATGROUP();
            this.SENDCURRENTCURSOR({eId: this.Entrant.id, cResultId: this.SelectedResultId, cHeightId: this.Entrant.results[this.SelectedResultId].heightId});
            this.SETRESULTIDS({eId: this.SelectedEntrantId ,rId: this.SelectedResultId, src: 'cc', nRId: null, nEId: null});
        },
        saveEdit(){
            this.SENDHEATGROUP();
            this.SETRESULTIDS({eId: this.CEntryId ,rId: this.CResultId, src: 'other'});
        },        
        refreshFields(){
            for(var i=0; i<this.Entrant.results.length; i++){
                if(!this.overAllResult[this.cEntrantId]) this.overAllResult[this.cEntrantId] = [];
                    this.overAllResult[this.cEntrantId][i] = (this.Entrant.results[i].highjumpTries || '').replace("-", "");
            }
            this.resultString = this.Entrant.results[this.cResultId].highjumpTries || '';
            this.originalResultString = JSON.parse(JSON.stringify(this.Entrant.results[this.cResultId].highjumpTries || ''));
            this.$refs.result.focus();
        },
        nextEntrant(skipRaise){
            if(this.Entrant.results.length != 0){
                if(this.ConnectionState === 1) {
                    this.SENDCURRENTCURSOR({eId: this.SelectedHeat.entries[this.nextEntrantId].id, cResultId: this.nextResultId, cHeightId: this.SelectedHeat.entries[this.nextEntrantId].results[this.nextResultId].heightId});                
                    if(!skipRaise) {
                        this.SETRESULTIDS({eId: this.nextEntrantId ,rId: this.nextResultId, src: 'cc', nEId: null, nRId:null});
                    }
                }  
                else{
                    this.nextEntrantId = this.cEntrantId + 1;
                    this.nextResultId = this.cResultId;

                    
                    for(var i=0; i<this.NextEntrant.results.length; i++){
                        if(!this.overAllResult[this.nextEntrantId]) this.overAllResult[this.nextEntrantId] = [];
                            this.overAllResult[this.nextEntrantId][i] = this.NextEntrant.results[i].highjumpTries.replace("-", "");
                    }

                    var searching = true;
                    while(searching) {
                        //End of List, start at beginning
                        if(this.nextEntrantId == this.selectedHeat.entries.length)
                            this.nextEntrantId = 0;

                        if(this.hasTries(this.nextEntrantId, this.nextResultId)){
                            searching=false;
                        }

                        //list searched till actual Entrant. Rais height
                        if(searching && this.nextEntrantId == this.cEntrantId) {
                            this.nextEntrantId = -1;
                            this.nextResultId++;
                            if(this.selectedHeat.heights[this.nextResultId] == undefined){
                                searching=false;
                            }
                        }

                        if(searching)
                            this.nextEntrantId++;
                    }

                    this.SETRESULTIDS({eId: this.nextEntrantId ,rId: this.nextResultId, src: 'cc', nEId: null, nRId:null});
                }
                
            this.refreshFields(); 
            }
           
        },
        confirmValue(event, directInput){    
            this.$refs.result.focus();
            let val = '';
            if(directInput){
                val = event;
            }
            else{
                val = event.srcElement.innerText;
            }
            if(val.length == 1 && this.hasTries(this.cEntrantId, this.cResultId)){
                if(!this.overAllResult[this.cEntrantId]) this.overAllResult[this.cEntrantId] = [];
                this.overAllResult[this.cEntrantId][this.cResultId] = this.resultString.replace("-", "");

                if(val === 'r' && this.overAllResult[this.cEntrantId].slice(this.cResultId).join('') !== '') 
                    alert(this.$i18n.t('text.errorInvalidInput'));
                
                const position = this.overAllResult[this.cEntrantId].slice(0, this.cResultId+1).join("").length;
                let teststring = (this.overAllResult[this.cEntrantId].join('').slice(position-2, position+3));
                teststring = (`${teststring.slice(0,2)}${val}${teststring.slice(2,4)}`).replace('-', '');
                if(teststring.length != 3 && teststring.includes('XXX'))
                    alert(this.$i18n.t('text.errorInvalidInput'));

                this.resultString = this.resultString.concat(val);
                this.Entrant.results[this.cResultId].highjumpTries = this.resultString
                this.Entrant.results[this.cResultId].try++;                        
                this.overAllResult[this.cEntrantId][this.cResultId] = this.resultString.replace("-", "");

                if(this.IsResultCurrent) {
                    this.SENDRESULT({result: this.Entrant.results[this.cResultId], eId: this.Entrant.id});
                }
            }
        },
        backSpace (event){  
            this.$refs.result.focus();  
            if(this.resultString.length !== 0) {        
                this.resultString = this.resultString.slice(0, -1);    
                this.Entrant.results[this.cResultId].try=this.resultString.length;            
                this.Entrant.results[this.cResultId].highjumpTries = this.resultString;
                this.overAllResult[this.cEntrantId][this.cResultId] = this.resultString;
                
                if(this.IsResultCurrent) {
                    this.SENDRESULT({result: this.Entrant.results[this.cResultId], eId: this.Entrant.id});
                }
            }
            
            if(event) event.stopPropagation();
            
        },
        onKeyDown(event){
            //console.log(event);
            switch (event.keyCode) {
                case 8: //backSpace
                    this.backSpace(event);
                    break;
                case 13: //enter
                    this.confirmValue(event);
                    break;
                case 109: // minus
                case 189: // dash
                    this.confirmValue('-', true);
                    break;
                case 82: //r and R
                    this.confirmValue('r', true);
                    break;
                case 88: //x and X
                    this.confirmValue('X', true);
                    break;
                case 48: // 0
                case 96: // 0
                case 79: //o and O
                    this.confirmValue('O', true);
                    break;
            }
            if(event) {
                event.stopPropagation();
                event.preventDefault();
            }
        },
        hasTries(eId, rId){
            //berücksichtige zb |XO|-|XX-|X =>Out
            if(this.SelectedHeat.heights[rId].jumpOff && !this.selectedHeat.entries[eId].results[rId].highjumpTries.includes('O') && !this.selectedHeat.entries[eId].results[rId].highjumpTries.includes('XXX'))
                return true;
            if(this.selectedHeat.entries[eId].isEnabled === false || this.selectedHeat.entries[eId].results[rId].isEnabled === false)
                return false;
            if(this.overAllResult != "" && this.overAllResult[eId] != undefined && ("XXX" == this.overAllResult[eId].slice(0, rId+1).join('').slice(-3) || this.overAllResult[eId].slice(0, rId+1).join('').includes('r')))
                return false;
            if(this.selectedHeat.entries[eId].results[rId].highjumpTries != null){
                if (this.selectedHeat.entries[eId].results[rId].highjumpTries.includes('-'))
                    return false;
                if (this.selectedHeat.entries[eId].results[rId].highjumpTries.includes('O'))
                    return false;
                if (this.selectedHeat.entries[eId].results[rId].highjumpTries.length == 3)
                    return false;
            }
            return true;
        },        
        setStateNavi(){
            if(this.HeatState < 2){
                this.HIDENAVPOINT([5]);
                this.SHOWNAVPOINT([4]);
            }
            else if(this.HeatState === 2){
                this.HIDENAVPOINT([4]);
                this.SHOWNAVPOINT([5]);
            }
            else if(this.HeatState === 3){                
                this.UNSETHEATDATA();
                this.$router.push('/competition/events/');
            }
        },        
    },
    computed:{
        ...mapGetters(['ConnectionState','SelectedHeat', 'HeatState', 'SelectedEntrantId', 'SelectedResultId', 'IsResultCurrent', 'CEntryId', 'CResultId']),
        selectedHeat(){
            return this.SelectedHeat;
        },
        Entrant(){
            return this.selectedHeat.entries[this.cEntrantId];
        },
        NextEntrant(){
            if(this.selectedHeat.entries.length == this.nextEntrantId) this.nextEntrantId=0;
            return this.selectedHeat.entries[this.nextEntrantId];
        },        
        getNextResultId(){
            return this.nextResultId
        },
        getRank(){
            return this.Entrant.rank ? `${this.Entrant.rank}.` : (this.Entrant.withoutEval ? `${this.$i18n.t('text.noRankingShort')}` : '') ;
        },
    },
    mounted(){   
        this.setStateNavi();
        this.cEntrantId = this.SelectedEntrantId;        
        this.cResultId = this.SelectedResultId;
        this.refreshFields();
        if(this.SelectedEntrantId === this.CEntryId &&  this.SelectedResultId === this.CResultId) {
            this.nextEntrantId = this.SelectedEntrantId;
            this.nextResultId = this.SelectedResultId;
            this.nextEntrant(true);
        }
    },
    created(){
        var RegisterMethods = () => {
            this.REGISTERHUB({
                name: "ReceiveHeatGroupRankUpdate",
                method: this.request
            });
        }

        if(this.ConnectionState !== 0){
            RegisterMethods();
        }

        this.$store.subscribe((mutation, state) => {
            if(mutation.type == glMut.SETCONNECTION && state.glModule.connection != ""){
                RegisterMethods();
            }
        });
    },
    watch: {
        SelectedEntrantId(){
            this.cEntrantId = this.SelectedEntrantId;
            this.refreshFields();
        },
        SelectedResultId(){
            this.cResultId = this.SelectedResultId;
            this.refreshFields();
        },
        HeatState() {
            this.setStateNavi();
        },
    },
    beforeDestroy(){        
        this.UNREGISTERHUB({
                name: "ReceiveHeatGroupRankUpdate",
                method: this.request
        });
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .editor {
        padding: 10px;
        background-color: $form-bg-color;
        margin-top: 10px;
        padding-top: 5px;
    }

    .header {
        font-size:30px;
        font-weight: bold;
        

        .try {
            width: 25%;
            margin-left: auto;
            padding-right:10px;
            text-decoration: none;
            display:flex;

            select {
                color: $font-light-color;
                height: 100%;
                width:100%;
                background-color: $prim_shadow_color;
                font-size: 20px;
                padding-left: 13%;
            }
        }
    }

    .name-label {
        font-size:14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .results {
        min-height: 18px;
        padding-top:10px;
    }

    .result {
        border: solid 1px $sec_color_dark;
        min-width: 15px;
        padding: 0 5px;
        padding-top: 2px;
        text-align: center;
        margin: 0px 5px;
        font-weight: bold;
    }

    .start-pos::before, .bib::before {
        font: normal normal normal 30px "Material Design Icons";
    } 

    .footer {
        .start-pos::before, .bib::before {
            font: normal normal normal 14px "Material Design Icons";
        }        
    }

    .start-pos::before {
        content:"\F04BC";
    }

    .bib::before {
        content:"\F0631";
    }

    .result-input {
        margin-top:10px;

        .f-column {
            width:75%
        }
        .field {
            height:$height_mid;
            border: solid 1px $sec_color_dark;
            cursor: pointer;
            text-align: center;
            line-height: $height_mid;
            color:$seltec_color;
            font-size: 40px;
            font-weight: bold;
            justify-content: center;
        }        

        .ruler {
            position: relative;
        }

        .ruler::before {
            font: normal normal normal 24px/1 "Material Design Icons";
            color: $sec_bg_color;
            font-size:30px;
            line-height:$height_mid;
            position: absolute;
            padding-left: 10px;  
            height:$height_mid;

        }

        .ruler::before {
            content:"\F046D";
        }
        

        .rank {
            background-color:$seltec_color; 
            color: $font-dark-color; 
            width:25%; 
            font-size: 40px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        a{
            text-decoration: none;
        }

        a:focus {
            outline: none;

            .field::after {
                content:"|"; 
                position: relative;
                margin-right: -11px;
                top: -4px;
                
                animation: blink 1.3s linear infinite;
            }
        }

        .blink {
            animation: blink-bg 2s infinite alternate;
        }        

        @keyframes blink-bg {
            0% {
                background-color: $blink-dark-light;
            }

            100% {
                background-color: $blink-dark-dark;
            }  
        }

        @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 1; }
            50.01% { opacity: 0; }
            100% { opacity: 0; }
        }
    }

    .input {
        margin: 0 auto;
        padding:10px;
    }

    .button, .buttons div {
        border: solid 1px $sec_color_dark;
        cursor: pointer;
        min-height: $height_high;
        min-width: $height_high;
        line-height: $height_high;
        width:25%;
        text-align: center;
        font-weight: bold;
        margin:10px;
        background-color: $prim_shadow_color;
        font-size: 24px;
        img {
            width: 35px;
            padding-top: 60px;
        }
    }

    .del::before {
        vertical-align: -15%;
        font: normal normal normal 24px/1 "Material Design Icons";
        content:"\F0B5C";
    }

    button:active, .button:active, .buttons div:active {
        background-color: $sec_color_dark;
    }

    .success:active {
        background-color: $prim_success_color_dark!important;
    }

    .failed:active {
        background-color: $prim_aleart_color_dark!important;
    }

    .success {
        color: $font-dark-color;
        background-color: $prim_success_color!important;
    }

    .failed {
        background-color: $prim_aleart_color!important;
    }

    .disabled {
        opacity: 0.5;
    }    

    .footer {
        padding-top:33px;
        font-size:14px;
        font-weight: bold;
        color: $sec_bg_color;
        > div:first-of-type {
            padding-top: 14px;
        }
    }

    .arrow-buttons {
        min-height: $height_high;
        line-height: $height_high;
        height: $height_high;
        color:$font-light-color;
    }  
    
    .next {        
        margin:0px;
        margin-left: auto;
    }

    .next::after {
        font: normal normal normal 24px/1 "Material Design Icons";
        content:"\F09C2";
    } 

    button {
        height: $height_default;
        background-color: $prim_bg_color;
        border: solid 2px $seltec_color;
        color: $font-light-color;
        font-weight: bold;
        cursor: pointer;
        padding: 0px 15px;
    }

    button:nth-child(2) {
        margin: 0 auto;
    }

    @media screen and (max-width: 801px) {                
        .editor {
            margin:0 auto;
        }
    } 
    
    

    @media screen and (max-height: 680px) {  
            .footer {
            padding-top:10px;
            .button, .buttons div {
                min-height: $height_mid;
                line-height: $height_mid;
            }
        }
    }

</style>